import { defineComponent as _defineComponent } from 'vue'
import LoadingScreen from '@/components/LoadingScreen.vue';
import AppHeader from '@/components/layout/AppHeader.vue';
import AppSidebar from '@/components/layout/AppSidebar.vue';

import {inject, onMounted, ref} from "vue";
import {LoggerService} from '@/services/logger/logger.service';
import {createRouterBeforeEach} from '@/router/before_each';

import "primevue/resources/themes/bootstrap4-light-blue/theme.css";
import "primeicons/primeicons.css";
import "primevue/resources/primevue.min.css";
import AppFooter from "@/components/layout/AppFooter.vue";
import dataService from './services/data.service';
import CurrentBlockchain from "@/components/layout/CurrentBlockchain.vue";
import { useRecaptchaProvider } from 'vue-recaptcha/head';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

useRecaptchaProvider();
const logger = inject<LoggerService>('logger') as LoggerService;
dataService.onAppStart();
const disclaimerOpen = ref();

onMounted(() => {
  createRouterBeforeEach(logger);
  disclaimerOpen.value = !localStorage.getItem('disclaimer');
});

window.onload = async () =>{
  dataService.onWindowLoad();
};


const __returned__ = { logger, disclaimerOpen, LoadingScreen, AppHeader, AppSidebar, AppFooter, CurrentBlockchain }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})